module.exports = __webpack_public_path__ + "img/valparaiso.538bd2b0.jpg";